import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories, stories } from "@/mocks/stories";

const iconMap: Record<string, string> = {
  business: "ri-store-3-line",
  industry: "ri-building-2-line",
  workplace: "ri-briefcase-4-line",
  gray: "ri-contrast-drop-2-line",
  network: "ri-global-line",
  society: "ri-home-smile-2-line",
};

export default function CategorySection() {
  const list = categories.filter((c) => c.id !== "all");

  return (
    <section className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="主题分类"
        title="按领域查找你关心的线索"
        desc="六个栏目覆盖商业、行业、职场、网络与民生场景，逐篇都可回溯信源类型。"
        actionHref="/stories"
        actionLabel="进入爆料库"
      />

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((cat) => {
          const count = stories.filter((s) => s.categoryId === cat.id).length;
          return (
            <Link
              key={cat.id}
              to={`/stories?category=${cat.id}`}
              className="group reveal flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100 cursor-pointer"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-900 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                <i className={`${iconMap[cat.id]} text-2xl`} aria-hidden="true"></i>
              </span>
              <span className="flex-1">
                <span className="flex items-center justify-between">
                  <span className="font-heading text-lg font-bold text-foreground-950">{cat.name}</span>
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-label font-medium text-accent-900">
                    {count} 篇
                  </span>
                </span>
                <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">{cat.desc}</span>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-label text-primary-700">
                  查看栏目
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}